import React, { Component } from "react";
import MenuItem from "material-ui/MenuItem";
import TextField from "components/form/text-field.js";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import Globalize from "globalize";
import SelectField from "../../form/select-field";
import { $, merge } from "glamor";
import Bottom from "../bottom";
import theme from "styles/theme";
import { toDataTest } from "helpers/test";

class DropDownFilter extends Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
    };

    wrapperStyles = merge(
        {
            display: "inline-block",
            width: "115px",
        },
        $(" .muiDropdown", {
            fontSize: "11px!important",
        }),
        $(" .muiDropdown div", {
            fontWeight: "100!important",
        }),
        $(" .muiDropdown div:nth-child(2)", {
            paddingLeft: "10px!important",
        })
    );

    styles = {
        container: {
            width: "inherit",
        },
        labelStyle: {
            fontWeight: "600",
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            fieldKey: props.filter[props.field],
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e, index, value) {
        const { filter, activeFiltersValues, onChange, field } = this.props;
        const { fieldKey } = this.state;
        const defaultItem = filter.__data.find((entry) => entry.__default);
        let filters;

        if (defaultItem && defaultItem.__value === value) {
            filters = activeFiltersValues.delete(fieldKey);
        } else {
            filters = activeFiltersValues.set(fieldKey, value);
        }

        onChange(filters, field);
    }

    render() {
        const { filter, activeFiltersValues } = this.props;
        const { fieldKey } = this.state;
        const { labelStyle, container } = this.styles;

        let defaultValue;

        const listItems = filter.__data.map((item, i) => {
            if (item.__default) {
                defaultValue = item.__value;
            }
            return (
                <MenuItem
                    key={"select-" + i}
                    data-test={`${toDataTest(filter.__key)}-condition-option`}
                    value={item.__value}
                    primaryText={item.__label}
                />
            );
        });

        return (
            <div {...this.wrapperStyles}>
                <SelectField
                    data-test={`${toDataTest(filter.__key)}-condition`}
                    name={Globalize.formatMessage("Condition")}
                    large={false}
                    label={Globalize.formatMessage("Condition")}
                    value={activeFiltersValues.get(fieldKey) || defaultValue}
                    onChange={this.handleChange}
                    style={container}
                    labelStyle={labelStyle}
                >
                    {listItems}
                </SelectField>
            </div>
        );
    }
}

class TextFilter extends Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
    };

    styles = {
        container: {
            float: "right",
            width: "60px",
        },
        inputStyle: {
            width: "inherit",
            fontSize: "11px",
            padding: "0 8px",
            appearance: "none",
        },
    };

    constructor(props) {
        super(props);
        const fieldKey = props.filter[props.field];
        this.state = {
            fieldKey,
            value: props.activeFiltersValues.get(fieldKey),
        };
    }

    handleChange = (_event, value) => this.setState({ value });

    sendChange = () => {
        const { activeFiltersValues, onChange, field } = this.props;
        const { fieldKey, value } = this.state;
        onChange(
            !value || value < 0 ? activeFiltersValues.delete(fieldKey) : activeFiltersValues.set(fieldKey, value),
            field
        );
    };

    componentDidUpdate(prevProps) {
        const fieldKey = this.state.fieldKey;
        const newValue = this.props.activeFiltersValues.get(fieldKey);
        if (prevProps.activeFiltersValues.get(fieldKey) !== newValue) {
            this.setState({ value: newValue });
        }
    }

    render() {
        const { filter } = this.props;
        const { value } = this.state;
        const { inputStyle, container, labelStyle } = this.styles;
        const label = <span style={labelStyle}>{Globalize.formatMessage("Value")}</span>;
        return (
            <TextField
                dataTest={`${toDataTest(filter.__key)}-value`}
                name={Globalize.formatMessage("Value")}
                placeholder={Globalize.formatMessage("Set Qty")}
                label={label}
                value={value || ""}
                type="number"
                min={0}
                large={false}
                style={container}
                inputStyle={inputStyle}
                debounce={false}
                onChange={this.handleChange}
                onEnter={this.sendChange}
                onBlur={this.sendChange}
            />
        );
    }
}

class InventoryFilter extends Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    styles = {
        nestedListItem: {
            backgroundColor: "transparent",
            paddingRight: "9px",
        },
        listItem: {
            margin: 0,
            padding: "3px 16px 3px 8px",
        },
        label: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
            color: theme.palette.darkerGrey,
        },
        longDropdownIcon: {
            marginRight: "-6px",
            marginTop: "5px",
        },
        longDropdownIconWithBadge: {
            top: "-6px",
            margin: "12px",
            right: "-13px",
        },
        shortListItemInner: {
            padding: "10px 0px 10px 8px",
        },
        longListItemInner: {
            width: "92%",
            padding: "10px 0px 10px 8px",
        },
        dropdownIcon: {
            top: -6,
            fontSize: "24px",
            color: "#757575",
            transition: "transform .1s",
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
        badgeContainer: merge(
            {
                position: "relative",
                width: "90%",
            },
            $(" .MuiBadge-root", {
                position: "static",
                padding: "0px",
            }),
            $(" .MuiBadge-badge", {
                top: 10,
                fontSize: "12px",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                color: theme.palette.darkerGrey,
                backgroundColor: theme.palette.lightGrey,
                fontFamily: "Lato, sans-serif",
            })
        ),
    };

    constructor(props) {
        super(props);
        this.state = {
            open: props.activeFiltersValues.has(props.filter.__condition_value_key) || props.filter.__default_open,
        };
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleToggleOpen = () => {
        this.setState({ open: !this.state.open });
    };

    handleChange(values, field) {
        const { onChange, filter } = this.props;
        const selectedCondition = values.get(filter.__condition_key);
        const conditionValue = values.get(filter.__condition_value_key);
        if (field === "__condition_key") {
            values = values.set(filter.__condition_key, selectedCondition);
        } else {
            values = values.set(filter.__condition_value_key, conditionValue);
        }
        onChange(values);
    }

    render() {
        const { filter, activeFiltersValues, lastFilter } = this.props;
        const styles = this.styles;
        const { open } = this.state;

        const title = filter.__name;
        let count = 0;
        const MAX_LINE_LENGTH = 25;
        let chevronIconStyle, listItemInnerDivStyle;

        const items = [
            <DropDownFilter
                key="condition"
                field="__condition_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
            />,
            <TextFilter
                key="condition_value"
                field="__condition_value_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
            />,
        ];

        ["__condition_key", "__condition_value_key"].forEach((key) => {
            if (activeFiltersValues.get(filter[key])) {
                count = count + 1;
            }
        });

        if (title.length > MAX_LINE_LENGTH) {
            chevronIconStyle = count === 0 ? styles.longDropdownIcon : styles.longDropdownIconWithBadge;
            listItemInnerDivStyle = styles.longListItemInner;
        } else {
            chevronIconStyle = styles.dropdownIcon;
            listItemInnerDivStyle = styles.shortListItemInner;
        }

        const itemLabel = <span style={styles.label}>{title}</span>;
        let badge = null;
        if (count === 2) {
            badge = (
                <div {...styles.badgeContainer}>
                    <Badge badgeContent={1} color="primary">
                        {itemLabel}
                    </Badge>
                </div>
            );
        }

        if (!lastFilter) {
            items.push(<Bottom key="bottom" />);
        }

        return (
            <React.Fragment>
                <ListItem button={true} style={styles.listItem} onClick={this.handleToggleOpen}>
                    <ListItemText primary={badge || itemLabel} />
                    <ChevronLeft
                        style={Object.assign({}, chevronIconStyle, open && styles.dropdownIconOpen)}
                        data-test={`chevron-${toDataTest(filter.__key)}`}
                    />
                </ListItem>
                <Collapse in={open} unmountOnExit timeout={100} style={styles.nestedListItem}>
                    <List style={listItemInnerDivStyle}>{items}</List>
                </Collapse>
            </React.Fragment>
        );
    }
}

export default InventoryFilter;
